export default [
  {
    name: "unionmember_index",
    path: "/unionweb/member",
    component: () => import("../pages/union/member/index.vue"),
  },
  {
    name: "unionmember_detail",
    path: "/unionweb/member/:uuid",
    component: () => import("../pages/union/member/detail.vue"),
    props: true,
  },

  // Settingan default untuk pengaturan Point Setting
  {
    name: "pointsetting_index",
    path: "/unionweb/pointsetting",
    component: () => import("../pages/union/pointsetting/default.vue"),
  },
  {
    name: "unionpoint_index",
    path: "/unionweb/point",
    component: () => import("../pages/union/point/index.vue"),
    props: true,
  },
  // ============================================================
  // MEMBER MISSIONS MODULE (MISSION, EVENT, TIER BONUS, YEARLY)
  // ============================================================
  // {
  //   name: "pointsetting_list",
  //   path: "/unionweb/pointsetting/list",
  //   component: () => import("../pages/union/pointsetting/index.vue"),
  // },

  // // LIST SPECIFIC CATEGORY
  // {
  //   name: "pointsetting_mission",
  //   path: "/unionweb/pointsetting/mission",
  //   component: () => import("../pages/union/pointsetting/mission.vue"),
  // },
  // {
  //   name: "pointsetting_event",
  //   path: "/unionweb/pointsetting/event",
  //   component: () => import("../pages/union/pointsetting/event.vue"),
  // },
  // {
  //   name: "pointsetting_tierbonus",
  //   path: "/unionweb/pointsetting/tier-bonus",
  //   component: () => import("../pages/union/pointsetting/tierbonus.vue"),
  // },
  // {
  //   name: "pointsetting_yearly",
  //   path: "/unionweb/pointsetting/yearly",
  //   component: () => import("../pages/union/pointsetting/yearly.vue"),
  // },

  // // UNIVERSAL CREATE / EDIT (DIPAKAI UNTUK SEMUA KATEGORI)
  // {
  //   name: "pointsetting_create",
  //   path: "/unionweb/pointsetting/create/:category",
  //   component: () => import("../pages/union/pointsetting/form.vue"),
  //   props: true,
  // },

  // {
  //   name: "pointsetting_edit",
  //   path: "/unionweb/pointsetting/:id/edit",
  //   component: () => import("../pages/union/pointsetting/form.vue"),
  //   props: true,
  // },

];
